module.exports = __webpack_public_path__ + "img/affiliate-banner-900x750.3327e19.jpg";